import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import API from "../api/api";
import { useLocation, useParams } from "react-router-dom";

const PERIODOS = {
  dia: 1,
  mes: 30,
  anho: 365,
};

function getDiasAlVencimiento(vencimiento) {
  if (!vencimiento) return 1;
  const hoy = new Date();
  const fechaVenc = new Date(vencimiento);
  const diffMs = Math.abs(
    fechaVenc.setHours(0, 0, 0, 0) - hoy.setHours(0, 0, 0, 0)
  );
  return Math.max(1, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
}

function calcularOfertaSugerida(monto, vencimiento, porcentaje, periodo) {
  const montoBase = Number(monto || 0);
  const porcentajeBase = Number(porcentaje || 0);

  if (!montoBase || !porcentajeBase || !PERIODOS[periodo]) {
    return {
      dias: getDiasAlVencimiento(vencimiento),
      descuentoPct: 0,
      descuentoMonto: 0,
      montoSugerido: montoBase,
    };
  }

  const dias = getDiasAlVencimiento(vencimiento);
  const factorPeriodo = dias / PERIODOS[periodo];
  const descuentoPct = (porcentajeBase / 100) * factorPeriodo;
  const descuentoMonto = montoBase * descuentoPct;
  const montoSugerido = Math.max(0, montoBase - descuentoMonto);

  return { dias, descuentoPct, descuentoMonto, montoSugerido };
}

/*
  Recibe:

  postData = {
    id,
    tipo,
    titulo,
    monto,
    vencimiento,
    descripcion,
    archivosAdjuntos: [
      { nombre, url }
    ],
    cliente: { id, nombre },
    compradoresBloqueados: [ <id_usuario>, ... ],
  }
*/

export default function VistaPublicaPost() {
  const location = useLocation();
  const params = useParams();
  const [data, setData] = useState(location.state?.postData || null);
  const [loading, setLoading] = useState(!location.state?.postData);

  const [oferta, setOferta] = useState("");
  const [comentario, setComentario] = useState("");
  const [porcentajeCalculadora, setPorcentajeCalculadora] = useState("");
  const [periodoCalculadora, setPeriodoCalculadora] = useState("mes");

  const usuario = JSON.parse(localStorage.getItem("usuario"));
  const compradorId = usuario?.id;

  const bloqueados =
    data?.compradores_bloqueados || data?.compradoresBloqueados || [];

  const estaBloqueado = bloqueados.includes(compradorId);
  const calculo = calcularOfertaSugerida(
    data?.monto,
    data?.vencimiento,
    porcentajeCalculadora,
    periodoCalculadora
  );

  useEffect(() => {
    const cargarPublicacion = async () => {
      if (data || !params.id) {
        setLoading(false);
        return;
      }

      try {
        const res = await API.get(`/publicaciones/${params.id}/`);
        setData(res.data);
      } catch (err) {
        console.error("Error cargando publicación:", err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    cargarPublicacion();
  }, [data, params.id]);




  const enviarOferta = async () => {
    if (!oferta || Number(oferta) <= 0) {
      alert("Ingrese un monto válido.");
      return;
    }

    try {
      const payload = {
        publicacion: data.id,
        monto: Number(oferta),
        comentario,
      };

      await API.post("/ofertas/crear/", payload);

      alert(
        `Oferta enviada con éxito.\nMonto: ${Number(
          oferta
        ).toLocaleString("es-PY")} Gs`
      );

      setOferta("");
      setComentario("");
    } catch (err) {
      console.error("Error enviando oferta:", err);

      alert(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          "No se pudo enviar la oferta."
      );
    }
  };

  if (loading) {
    return <p className="text-slate-500 text-center">Cargando publicación...</p>;
  }

  if (!data)
    return (
      <p className="text-slate-500 text-center">
        No se encontró la publicación.
      </p>
    );

  return (
    <div className="space-y-6">
      {/* TITULO */}
      <h1 className="text-2xl font-bold text-primary">
        Publicación #{data.id}
      </h1>
      <p className="text-slate-600">
        Revise los datos antes de enviar una oferta.
      </p>

      {/* DATOS */}
      <Card>
        <h2 className="text-lg font-semibold text-primary mb-3">
          {data.titulo}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
          <p className="capitalize">
            <b>Tipo:</b> {data.tipo}
          </p>

          <p>
            <b>Monto:</b>{" "}
            {Number(data.monto).toLocaleString("es-PY")} Gs
          </p>

          <p>
            <b>Vencimiento:</b> {data.vencimiento}
          </p>

          <p>
            <b>Cliente:</b> {data.cliente_nombre || data.cliente?.nombre || "N/D"}
          </p>
        </div>

        {/* Descripción */}
        {data.descripcion && (
          <div className="mt-4">
            <h3 className="text-sm font-semibold text-primary">Descripción</h3>
            <p className="text-sm text-slate-600 mt-1">
              {data.descripcion}
            </p>
          </div>
        )}

        {/* Archivos adjuntos */}
        <div className="mt-6">
          <h3 className="text-sm font-semibold text-primary mb-2">
            Archivos adjuntos
          </h3>

          {!(data.archivos_adjuntos || data.archivosAdjuntos)?.length ? (
            <p className="text-sm text-slate-500">
              No hay archivos adjuntos.
            </p>
          ) : (
            <div className="flex flex-wrap gap-4">
              {(data.archivos_adjuntos || data.archivosAdjuntos).map((file, index) => (
                <div
                  key={index}
                  className="border rounded p-2 bg-slate-50 text-xs text-center w-32"
                >
                  <div className="h-20 bg-gray-200 rounded overflow-hidden mb-2 flex items-center justify-center">
                    <img
                        src={file.url || file.archivo}
                        alt={file.nombre}
                        className="h-full object-cover"
                      />
                  </div>
                  {file.nombre}
                </div>
              ))}
            </div>
          )}
        </div>
      </Card>

      {/* BLOQUEADO */}
      {estaBloqueado && (
        <Card className="bg-red-100 text-red-700">
          <h3 className="font-bold text-lg">No puedes ofertar</h3>
          <p className="text-sm mt-1">
            Has sido bloqueado para esta publicación por un pago fallido
            anterior.
          </p>
        </Card>
      )}

      {/* FORMULARIO */}
      {!estaBloqueado && (
        <Card className="space-y-4">
          <h2 className="text-lg font-semibold text-primary">
            Realizar oferta
          </h2>

          <div className="p-3 border rounded bg-slate-50 space-y-3">
            <h3 className="font-semibold text-primary text-sm">
              Calculadora de oferta
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <input
                type="number"
                step="0.01"
                className="border rounded p-2 w-full"
                placeholder="Porcentaje"
                value={porcentajeCalculadora}
                onChange={(e) => setPorcentajeCalculadora(e.target.value)}
              />
              <select
                className="border rounded p-2 w-full"
                value={periodoCalculadora}
                onChange={(e) => setPeriodoCalculadora(e.target.value)}
              >
                <option value="dia">Por día</option>
                <option value="mes">Por mes</option>
                <option value="anho">Por año</option>
              </select>
            </div>
            <p className="text-xs text-slate-600">
              Días al vencimiento: {calculo.dias} | Descuento estimado: {(calculo.descuentoPct * 100).toFixed(2)}%
            </p>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
              <p className="text-sm">
                Oferta sugerida: <b>Gs {Math.round(calculo.montoSugerido || 0).toLocaleString("es-PY")}</b>
              </p>
              <Button
                className="bg-slate-700 hover:bg-slate-800"
                onClick={() => setOferta(String(Math.round(calculo.montoSugerido || 0)))}
              >
                Usar monto calculado
              </Button>
            </div>
          </div>

          <input
            type="number"
            className="border rounded p-2 w-full"
            placeholder="Monto ofrecido en Gs"
            value={oferta}
            onChange={(e) => setOferta(e.target.value)}
          />

          <textarea
            className="border rounded p-2 w-full text-sm"
            placeholder="Comentario (opcional)"
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
          />

          <Button
            className="bg-primary text-white w-full"
            onClick={enviarOferta}
          >
            Enviar oferta
          </Button>
        </Card>
      )}
    </div>
  );
}
